import { connect } from 'react-redux';

import {
  actionCleanupDiscoverPlaceDetails,
  actionDeleteDiscoverPlace,
  actionGetDiscoverPlaceDetails,
} from 'store/actions';
import {
  actionCleanupDiscoverReviews,
  actionDeleteDiscoveryReview,
  actionGetDiscoveryReviews,
} from 'store/discover-review/actions';
import ManagerDiscoveryPlaceDetails from './ManagerDiscoveryPlaceDetails';

const mapStateToProps = (state) => ({
  discoverPlaceDetails: state.DiscoverPlace.discoverPlaceDetails,
  discoverPlaceDetailsLoading: state.DiscoverPlace.discoverPlaceDetailsLoading,

  reviews: state.DiscoverReview.reviews,
  reviewsLoading: state.DiscoverReview.reviewsLoading,

  isDeleteDiscoveryReviewLoading: state.DiscoverReview.deleteDiscoveryReviewLoading,

  deleteLoading: state.DiscoverPlace.deleteLoading,
});

const mapDispatchToProps = ({
  actionGetDiscoverPlaceDetails,
  actionCleanupDiscoverPlaceDetails,

  actionGetDiscoveryReviews,
  actionCleanupDiscoverReviews,

  actionDeleteDiscoveryReview,

  actionDeleteDiscoverPlace,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManagerDiscoveryPlaceDetails);
